import React from "react"
import { useShallow } from "zustand/react/shallow"
import { useParams } from "react-router-dom"

// components
import Authoring from "./Authoring"
import SidePanelContainer from "./subcomponents/SidePanelContainer/SidePanelContainer"
import FormActions from "./subcomponents/FormActions/FormActions"
import FormNavigator from "./subcomponents/FormNavigator/FormNavigator"

// api hooks
import { useGetStudy } from "api/hooks/studies/useStudiesApi"
import { useGetAuthoringStudy } from "api/hooks/studies/useAuthoringApi"

// context
import useAuthoringActions from "./hooks/actions/useAuthoringActions"
import useAuthoringViewStore from "./hooks/stores/useAuthoringViewStore"

// styles
import "./AuthoringContainer.scss"

const AuthoringContainer = () => {
  const { studyId, authoringId } = useParams()
  const { data: study } = useGetStudy(studyId)
  const { data: authoring, isFetching: authoringIsLoading } = useGetAuthoringStudy(authoringId)

  const formDataRef = React.useRef()

  const { fullScreen, showPagePreview } = useAuthoringViewStore(
    useShallow((state) => ({
      fullScreen: state.fullScreen,
      showPagePreview: state.showPagePreview,
    }))
  )

  const { sectDropdownOptions, onChangeSection } = useAuthoringActions(
    useShallow((state) => ({
      sectDropdownOptions: state.sectDropdownOptions,
      onChangeSection: state.onChangeSection,
    }))
  )

  const classNames = ["authoring-container"]
  if (fullScreen) classNames.push("authoring-full-screen")

  return (
    <div className={classNames.join(" ")}>
      <FormActions formDataRef={formDataRef} />
      <div className="auth-form-content">
        {sectDropdownOptions && fullScreen !== true && (
          <FormNavigator
            sectDropdownOptions={sectDropdownOptions
              .filter((item) => {
                if (showPagePreview) {
                  if (item.text === "Sponsor Trial Website" || item.text === "Study Details") return false
                  return true
                }
                if (
                  formDataRef?.current?.protocol?.study_type !== "Interventional" &&
                  item.id === "delayedResultsCertification"
                )
                  return false
                return true
              })
              .map((item) => item.text)}
            onChangeSection={onChangeSection}
          />
        )}
        <Authoring
          study={study}
          authoring={authoring}
          authoringIsLoading={authoringIsLoading}
          formDataRef={formDataRef}
        />
        <SidePanelContainer />
      </div>
    </div>
  )
}

export default AuthoringContainer
